import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar, OfferBar } from './components/Countdown';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-night font-body text-white" data-id="element-0" data-mp="23u9tmmkgrbwr">
      <MetaPixel data-id="element-1" data-mp="3ijxq4swlw4ky" />
      <TopBar data-id="element-2" data-mp="3ikh7o8icgqyg" />
      <main data-id="element-3" data-mp="3ikqwhsrnks2k">
        <Hero data-id="element-4" data-mp="3ij66mgga9xb1" />
        <Stats data-id="element-5" data-mp="3ijpbavgxap74" />
        <QuickTestimonials data-id="element-6" data-mp="3ihuyy5jpw5en" />
        <Problems data-id="element-7" data-mp="3mlatmwc87vop" />
        <SystemOverview data-id="element-8" data-mp="3mkhlps1j704z" />
        <Modules data-id="element-9" data-mp="3mjztd6hzp62c" />
        <Bonuses data-id="element-10" data-mp="3mjg8pi0yg3km" />
        <OfferBar data-id="element-11" data-mp="3rc9co3oln7vn" />
        <Pricing data-id="element-12" data-mp="3rbrcivytg9ig" />
        <Testimonials data-id="element-13" data-mp="3rdatkosaqola" />
        <Guarantee data-id="element-14" data-mp="3rd1a7k1rbfok" />
        <Faq data-id="element-15" data-mp="3relv0hy9rk98" />
        <Comparison data-id="element-16" data-mp="5ot150vj28n" />
        <FinalCta data-id="element-17" data-mp="680tswt8a8y" />
      </main>
      <Footer data-id="element-18" data-mp="5ggxfcks0yi" />
      <PurchasePopup data-id="element-19" data-mp="82k72sfnuax" />
    </div>;
}